import get from 'lodash/get';

import { AppRootState } from '../../../../../store/models/app-state.model';
import { APPS, APPS_FEATURE } from '../../../../../store/utils/files-names';

export const getAreAppsFiltersVisible = (state: AppRootState): boolean =>
  get(state, `${APPS_FEATURE}.${APPS}`).areAppsFiltersVisible;
